// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hER-","colBig":"styles_colBig__3267Y","colSmall":"styles_colSmall__3OmjL"};